module.exports = __webpack_public_path__ + "img/horizontal_6_7_pp13_9005.9ac0aaff.png";